/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loader from "../../common/Loader";
import TimeDisplay from "../../common/TimeDisplay";
import { useLocation } from "react-router-dom";
import ConstantsList from '../../common/Constants';

//Redux
import { useSelector } from "react-redux";

const Leftside = () => {
  let [getMenu, setMenu] = useState([]);
  let userData = useSelector((state) => state?.user); // User Details from Store
  let menuData = useSelector((state) => state?.menu); // User Details from Store
  const location = useLocation();
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  // Get from Menu.json
  const loadMenu = () => {
    // Get Data from Store
    setMenu(menuData?.data);
  };

  const LoadParent = ({ value }) => {
    const isParentActive = value.children?.some(
      (child) => child.hrefLink === location.pathname
    );
    const isCurrentParent = value.hrefLink === location.pathname;
  
    const parentClass = value.children?.length
      ? `nav-link dropdownMenu ${isParentActive ? "" : "collapsed"}`
      : isCurrentParent
      ? "nav-link active"
      : "nav-link collapsed";
  
    return (
      <li key={value.name} className="nav-item">
        {value.children?.length ? (
          <>
            <a
              className={parentClass}
              data-bs-target={value.data_bs_targetp}
              data-bs-toggle="collapse"
              href="#"
            >
              <i className={value.icon}></i>
              <span>{value.name}</span>
              <i className="bi bi-chevron-down ms-auto"></i>
            </a>
            <ul
              id={value.data_bs_target}
              className={`nav-content collapse ${isParentActive ? "show" : ""}`}
              data-bs-parent="#sidebar-nav"
            >
              {value.children.map((child) => {
                const isChildActive = child.hrefLink === location.pathname;
                return (
                  <li key={child.name} className="nav-item">
                    <Link
                      to={child.hrefLink}
                      className={`nav-link subMenu ${isChildActive ? "active" : "collapsed"}`}
                    >
                      <i className={child.icon}></i>
                      <span>{child.name}</span>
                    </Link>
                  </li>
                );
              })}
            </ul>
          </>
        ) : (
          <Link to={value.hrefLink} className={parentClass}>
            <i className={value.icon}></i>
            <span>{value.name}</span>
          </Link>
        )}
      </li>
    );
  };

  useEffect(() => {
    // console.log(">> Menu Loaded ");
    loadMenu();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [menuData]);

  return (
    <>
      <div className="main-sidebar">
        <aside id="sidebar" className="sidebar">
          <nav>
            <ul className="sidebar-nav" id="sidebar-nav">
              {
                <Loader
                  isLoading={!userData?.status}
                  className={"text-center"}
                />
              }

              {/* Menu */}
              {/* {userData?.data?.category === "ADMIN" && <li className="nav-item">
                <Link to={ConstantsList.MENU_CONFIGURATION} className={`nav-link ${location.pathname === ConstantsList.MENU_CONFIGURATION ? "active" : "collapsed"}`}>
                  <i className="bi bi-menu-button-wide" aria-hidden="true" /><span>Roles and menus</span>
                </Link>
              </li>} */}
              {userData?.status && getMenu.length
                ? getMenu.map((value, index) => {
                    return <LoadParent key={index} value={value} />;
                  })
                : null}
            </ul>
          </nav>
          {/* <TimeDisplay timezone={userTimezone} /> */}
        </aside>
      </div>
    </>
  );
};

export default Leftside;
